import { Box, Button, Grid, Paper, Typography } from '@mui/material';
import React from 'react';
import { observer } from 'mobx-react';
import VivaIntegration from './VivaIntegration';
import PersonalkollenIntegration from './PersonalkollenIntegration';
import AddIntegrationModal from './AddIntegrationModal';
import { useIntegrationsList } from '../../../stores/FetcherStores/integrationFetcher';
import useCompanyId from '../../../hooks/useCompanyId';

const Integrations = observer(() => {
  const companyId = useCompanyId();
  const { data: integrations, isLoading } = useIntegrationsList(companyId);

  const [open, setOpen] = React.useState(false);

  return (
    <Box>
      <Typography variant="h1" gutterBottom>
        Integrationer
      </Typography>
      <Button variant="contained" onClick={() => setOpen(true)}>
        Lägg till integration
      </Button>
      {isLoading && !integrations && (
        <Paper sx={{ marginTop: 2, marginBottom: 2, padding: '1rem' }}>
          <Box sx={{ display: 'flex', justifyContent: 'center', padding: 2 }}>
            <Typography variant="h6">Laddar integrationer...</Typography>
          </Box>
        </Paper>
      )}
      {integrations?.map((integration) => {
        return (
          <Paper sx={{ marginTop: 2, marginBottom: 2, padding: '1rem' }} key={integration.id}>
            <Grid item xs={12} md={6}>
              {integration.type === 'VIVA' && <VivaIntegration integrationId={integration.id} />}
              {integration.type === 'PERSONALKOLLEN' && (
                <PersonalkollenIntegration integrationId={integration.id} />
              )}
            </Grid>
          </Paper>
        );
      })}
      {integrations && integrations.length === 0 && (
        <Paper sx={{ marginTop: 2, marginBottom: 2, padding: '1rem' }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <Typography variant="h6" gutterBottom>
              Ingen integrationer tillagda
            </Typography>
            <Button variant="contained" onClick={() => setOpen(true)}>
              Lägg till integration
            </Button>
          </Box>
        </Paper>
      )}
      <AddIntegrationModal
        open={open}
        onClose={() => {
          setOpen(false);
        }}
      />
    </Box>
  );
});

export default Integrations;
